import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  productListResource,
  ProductList,
} from "@megarax/client/src/resources/plm";

export const productListModule: ResourceAppModule = {
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  iconClass: "fas fa-clipboard-list fa-fw",
  title: "Listy produktowe",
  route: "listaProduktowa",
  app: plmApp,
  resource: productListResource,
  itemConstructor: ProductList,
};
